export default "__VITE_ASSET__Bmv02MOb__"